import { useTranslation } from "react-i18next";
import { Button } from "@/components/base/buttons/button";
import { useChatAI } from "./chat-ai-context";
import { getCurrentUserType } from "@/components/application/command-menu/command-menu-search";

export const ChatInitialScreen = () => {
    const { t } = useTranslation(['common']);
    const { setActiveWizard, setWizardFormData, setQuoteRequestId } = useChatAI();
    const userType = getCurrentUserType();

    const handleActionClick = (wizardType: "container" | "order" | "quote_request" | "quote_response") => {
        setActiveWizard(wizardType);
        setWizardFormData({});
        if (wizardType === "quote_response") {
            // Per quote_response, il quoteRequestId verrà impostato dal contesto o dalla selezione
            setQuoteRequestId(null);
        }
    };

    const getActions = (): Array<{ label: string; wizardType: "container" | "order" | "quote_request" | "quote_response" }> => {
        switch (userType) {
            case "SHIPPER":
                return [
                    { label: t('aiChat.actions.createQuoteRequest'), wizardType: "quote_request" },
                    { label: t('aiChat.actions.createContainer'), wizardType: "container" },
                ];
            case "RECEIVER":
                return [
                    { label: t('aiChat.actions.createOrder'), wizardType: "order" },
                ];
            case "FREIGHT_FORWARDER":
                return [
                    { label: t('aiChat.actions.createQuote'), wizardType: "quote_response" },
                ];
            default:
                return [];
        }
    };

    const actions = getActions();

    return (
        <div className="flex h-full w-full flex-col items-center justify-center px-4 py-8">
            <div className="max-w-md w-full space-y-6">
                <div className="text-center">
                    <h3 className="text-xl font-semibold text-primary mb-2">
                        {t('aiChat.welcome')}
                    </h3>
                    <p className="text-sm text-tertiary">
                        {t('aiChat.welcomeSubtitle')}
                    </p>
                </div>

                <div className="space-y-3">
                    {actions.map((action) => (
                        <Button
                            key={action.wizardType}
                            onClick={() => handleActionClick(action.wizardType)}
                            color="primary"
                            size="lg"
                            className="w-full"
                        >
                            {action.label}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
};

